export default {"src":"/_next/static/media/Bluesky_Logo.12052776.svg","height":530,"width":600,"blurWidth":0,"blurHeight":0};